<div class="container">
  <div class="close" (click)="closeModal()"><mat-icon>close</mat-icon></div>
  <div class="flex">
    <h3 style="margin: 0">Sim Details</h3>
    @if (checkingRadiusState) {
    <mat-spinner name="crescent"></mat-spinner>
    }
    <div class="flex-row-gapped">
      @if (canDisableSims &&
          radiusLive && (sim["ServiceProvider"]=="SA - Vodacom" || sim["ServiceProvider"]=="SA - MTN") &&
          ((!sim.Disabled && sim['Status'] == 'Activated') ||
				  (sim.Disabled && (sim['Status'] == 'Soft Locked' || sim['Status'] == 'Network Blocked')))) {
        <button mat-raised-button class="disable-button" (click)="blockSim()">{{(sim.Disabled || sim['Status'] == 'Soft Locked' || sim['Status'] == 'Network Blocked') ? "Enable" : "Disable"}}</button>
      }
      @if (sim.StatusChangeTimestamp != null && sim.Disabled) {
        <div class="small-text">Disabled on: {{ sim.StatusChangeTimestamp | date:'yyyy-MM-dd HH:mm:ss.SSS':'UTC' }}</div>
      }
      @if (radiusLive && (sim.Disabled && sim['Status'] == 'Capped')) {
        <div class="small-text">Sim is capped. Please uncap entire device</div>
      }
    </div>
    @if (radiusLive &&
        !((!sim.Disabled && sim['Status'] == 'Activated') ||
        (sim.Disabled && (sim['Status'] == 'Soft Locked' || sim['Status'] == 'Network Blocked'))) &&
        sim['Status'] != 'Capped') {
      <div class="small-text">Sim status currently updating. Cannot disable/enable sim</div>
    }
    @if (!radiusLive && !checkingRadiusState) {
      <div class="small-text">Radius server not live. Cannot disable/enable sim</div>
    }
  </div>
  @if (sim == null) {
  <div> No sim info found </div>
  } @if (sim != null) {
  <div>
    <huge-row>
      <mat-col>Sim Num:</mat-col>
      <mat-col class="bold text-right">{{ sim.SimNum }}</mat-col>
    </huge-row>
    <huge-row>
      <mat-col>Cell:</mat-col>
      <mat-col class="bold text-right">{{ sim.SimCell }}</mat-col>
    </huge-row>
    <huge-row>
      <mat-col>Network:</mat-col>
      <mat-col class="bold text-right">{{ sim.ServiceProvider }}</mat-col>
    </huge-row>
    <huge-row>
      <mat-col>Status:</mat-col>
      <mat-col class="bold text-right">{{ sim.Status }}</mat-col>
    </huge-row>
    @if (sim.Disabled) {
    <div>
      <huge-row>
        <mat-col>Disabled By:</mat-col>
        <mat-col class="bold text-right">{{ sim.IsPortalUserDisabling || sim.IsApiUserDisabling ? (sim.DisabledByUser ?? "Unknown") : (sim.DisabledByUser.includes("Cap Man") ? "HugeConnect (Auto Blocked)" : "HugeConnect") }}</mat-col>
      </huge-row>
    </div>
    } @if (sim.APNInfo && sim.APNInfo.length > 0) {
    <h3 class="apn-header">APN IP's</h3>
    
    <div class="apn-list">
      @for (apnInfo of sim.APNInfo; track apnInfo) {
      <div class="apn-item">
        <div class="item">
          <div class="text-right">{{ apnInfo.APN == null ? 'Unknown' : (apnInfo.APN | apnPipe : sim.ServiceProvider) }}:</div>
        </div>
        <div class="item">
          <div class="text-right" [style.color]="'red'">{{ apnInfo.Blocked ? 'Blocked' : '' }}</div>
        </div>
        <div class="item">
          <div class="text-right">{{ apnInfo.IP || 'Unknown' }}</div>
        </div>
      </div>
      }
    </div>
  }
  </div>
  }
</div>
